import React, { useState, useEffect } from 'react';

function CookieBar() {
    const [isVisible, setIsVisible] = useState(true);
    const [cookieAccepted, setCookieAccepted] = useState(false);

    useEffect(() => {
        const isCookieAccepted = localStorage.getItem('cookieAccepted');
        if (isCookieAccepted === 'true') {
            setCookieAccepted(true);
            setIsVisible(false);
        }
    }, []);

    const hideParentDiv = () => {
        localStorage.setItem('cookieAccepted', 'true');
        setCookieAccepted(true);
        setIsVisible(false);
    };

    return (
        <>
            {!cookieAccepted && isVisible && (
                <div className="CookiePopupCookie"
                    style={{
                        borderRadius: "3px 3px 0px 0px",
                        padding: "15px",
                        height: "auto",
                        width: "100%",
                        backgroundColor: "rgba(156, 89, 209 ,0.9)",
                        position: "fixed",
                        right: "0px",
                        bottom: "0px",
                        zIndex: 6,
                        boxSizing: "border-box",
                    }}
                >
                    <div
                        className="CookiePopupContent"
                        style={{ boxSizing: "inherit", textAlign: "center" }}
                    >
                        <div
                            className="CookiePopupDesc"
                            style={{
                                boxSizing: "inherit",
                                lineHeight: "17px",
                                color: "rgb(255, 255, 255)",
                                display: "inline-block",
                                width: "70%",
                                verticalAlign: "middle",
                                textAlign: "left",
                            }}
                        >
                            <p
                                style={{
                                    boxSizing: "inherit",
                                    fontSize: "1rem",
                                    lineHeight: "1.5em",
                                    color: "rgb(255, 255, 255)",
                                }}
                            >
                                By using the website, you are agreeing to our{" "}
                                <a
                                    className="privacy_opt"
                                    href="/privacypolicy"
                                    rel="noopener"
                                    target="_blank"
                                    style={{
                                        boxSizing: "inherit",
                                        backgroundPosition: "center bottom 0.05em",
                                        transition: "color 400ms ease 0s",
                                        textDecoration: "none",
                                        background: "transparent",
                                        color: "rgb(0,0,0)",
                                        backgroundImage: "initial",
                                        backgroundSize: "initial",
                                        backgroundRepeat: "initial",
                                        textShadow: "none",
                                    }}
                                >
                                    Privacy Policy
                                </a>
                                ,{" "}
                                <a
                                    className="terms_opt"
                                    href="/termsconditions"
                                    rel="noopener"
                                    target="_blank"
                                    style={{
                                        boxSizing: "inherit",
                                        backgroundPosition: "center bottom 0.05em",
                                        transition: "color 400ms ease 0s",
                                        textDecoration: "none",
                                        background: "transparent",
                                        color: "rgb(0,0,0)",
                                        backgroundImage: "initial",
                                        backgroundSize: "initial",
                                        backgroundRepeat: "initial",
                                        textShadow: "none",
                                    }}
                                >
                                    Terms & Conditions
                                </a>{" "}
                                and the use of cookies in accordance with our{" "}
                                <a
                                    className="privacy_opt"
                                    href="/cookiepolicy"
                                    rel="noopener"
                                    target="_blank"
                                    style={{
                                        boxSizing: "inherit",
                                        backgroundPosition: "center bottom 0.05em",
                                        transition: "color 400ms ease 0s",
                                        textDecoration: "none",
                                        background: "transparent",
                                        color: "rgb(0,0,0)",
                                        backgroundImage: "initial",
                                        backgroundSize: "initial",
                                        backgroundRepeat: "initial",
                                        textShadow: "none",
                                    }}
                                >
                                    Cookie Policy
                                </a>
                                .
                            </p>
                        </div>
                        <div
                            className="CookiePopupBtnContainer"
                            style={{
                                boxSizing: "inherit",
                                padding: "0px",
                                display: "inline-block",
                                color: "rgb(255, 255, 255)",
                                marginLeft: "20px",
                                backgroundColor: "transparent",
                                top: "0px",
                                right: "0px",
                                zIndex: 7,
                                lineHeight: 1,
                            }}
                        >
                            <button
                                className="CookiePopupBtn"
                                style={{
                                    boxSizing: "inherit",
                                    appearance: "none",
                                    border: "1px solid rgb(255, 255, 255)",
                                    padding: "12px 48px",
                                    overflow: "visible",
                                    outline: "0px",
                                    transition: "all 400ms ease 0s",
                                    borderRadius: "2px",
                                    background: "none",
                                    position: "relative",
                                    display: "inline-block",
                                    fontSize: "11px",
                                    fontStyle: "normal",
                                    color: "rgb(255, 255, 255)",
                                    lineHeight: "12px",
                                    textTransform: "uppercase",
                                    textAlign: "center",
                                    cursor: "pointer",
                                    fontWeight: 700,
                                    fontFamily:
                                        'FoundryContextW03Md',
                                    letterSpacing: "1.5px",
                                }} onClick={hideParentDiv}
                            >
                                Accept
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}

export default CookieBar;
